import React from 'react';
import { AUVersion, DEFAULT_AU_VERSION, featureAvailable } from '../blueprints';

interface BlueprintContextValue {
  auVersion: AUVersion;
  setAuVersion: (v: AUVersion) => void;
  feat: (featureKey: string) => boolean;
}

export const BlueprintContext = React.createContext<BlueprintContextValue>({
  auVersion: DEFAULT_AU_VERSION,
  setAuVersion: () => {},
  feat: () => true,
});

export const useBlueprintContext = () => React.useContext(BlueprintContext);

interface BlueprintProviderProps {
  children: React.ReactNode;
  auVersion: AUVersion;
  setAuVersion: (v: AUVersion) => void;
}

export const BlueprintProvider: React.FC<BlueprintProviderProps> = ({ children, auVersion, setAuVersion }) => {
  const feat = React.useCallback(
    (key: string) => featureAvailable(key, auVersion),
    [auVersion],
  );

  return (
    <BlueprintContext.Provider value={{ auVersion, setAuVersion, feat }}>
      {children}
    </BlueprintContext.Provider>
  );
};
